import React, { useEffect } from 'react'

//css
import '../EnterpriseSecurity.scss'
import images from '../../../../../Assets/Images';
import StickyHeader from '../../Header/StickyHeader';
import Footer from '../../Footer/Footer';
import ComponentHeader from '../../../../ComponentHeader/ComponentHeader';

const SecurityDetails = [
  { title: 'HIPPA', description: 'The Health Insurance Portability and Accountability Act of 1996 (HIPAA) is legislation that is designed to make it easier for US workers to retain health insurance coverage when they change or lose their jobs. The legislation also seeks to encourage electronic health records to improve the efficiency and quality of the US healthcare system through improved information sharing.', imgUrl: images.Hipaa },
  { title: 'HITRUST', description: 'The HITRUST CSF (Cloud Security Framework) serves to unify security controls based on aspects of US federal law (such as HIPAA and HITECH), state law (such as Massachusetts’ Standards for the Protection of Personal Information of Residents of the Commonwealth) and recognized non-governmental compliance standards (such as PCI DSS) into a single framework that is tailored for healthcare needs.', imgUrl: images.Hitrust },
  { title: 'HITECH', description: 'Health Information Technology for Economic and Clinical Health Act (HITECH) expanded the HIPAA rules in 2009. HIPAA and HITECH together establish a set of federal standards intended to protect the security and privacy of PHI.', imgUrl: images.Hitech },
  { title: 'FedRAMP', description: 'The Federal Risk and Authorization Management Program (FedRAMP) is a government-wide program that promotes the adoption of secure cloud services across the federal government by providing a standardized approach to security assessment, authorization, and continuous monitoring for cloud products and services.', imgUrl: images.Fedramp },
  { title: 'AICPASOC', description: 'System and Organization Controls (SOC) Reports are independent third-party examination reports that demonstrate how powered by CentiBlick achieves key compliance controls and objectives. The purpose of these reports is to help you and your auditors understand the controls established to support operations and compliance.', imgUrl: images.AICPASOC },
  { title: 'GDPR', description: 'The European Union’s General Data Protection Regulation (GDPR) protects European Union (EU) individuals’ fundamental right to privacy and the protection of personal data. The GDPR includes robust requirements that raise and harmonize standards for data protection, security, and compliance.', imgUrl: images.GDPR },
]

const SecurityTrust = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='security-and-trust'>
      <StickyHeader />
      <div>
        <ComponentHeader title='Security & Trust' />
        <div className='security-and-trust-main-div common-container'>
          {/* <div className='img-div w-100 position-relative d-flex align-items-center'>
            <img src={images.SecurityTrustImage} alt="" className='w-100' />
            <h1 className='position-absolute'>Security & <br /> Trust</h1>
          </div> */}
          <div className='securities'>
            {SecurityDetails?.map((security) => (
              <div className='security-div gap-0'>
                <div className='security-title'>
                  <h1>{security.title}</h1>
                </div>
                <div className='d-flex justify-content-between align-items-start security-details'>
                  <img src={security.imgUrl} alt="" />
                  <p>
                    {security.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default SecurityTrust